import {
  CLEAR_INVOICES,
  HIDE_SPINNER,
  INVOICES_RECEIVED,
  SET_TOTAL,
  SHOW_SPINNER,
} from "../types";

const InvoicesReducer = (state, { type, payload }) => {
  switch (type) {
    case INVOICES_RECEIVED:
      return { ...state, invoices: payload };
    case CLEAR_INVOICES:
      return { ...state, invoices: null };
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    case SET_TOTAL:
      return { ...state, total: payload };
    default:
      return { ...state };
  }
};
export default InvoicesReducer;
